import { gql } from '@apollo/client';

export const getUserDraftArticleForParentArticle = gql`
  query userDraftArticleForParentArticle($parentArticleId: ID!) {
    authenticatedItem {
      ... on User {
        articles(
          where: {
            type: { equals: ARTICLE }
            status: { equals: "draft" }
            parentArticle: { id: { equals: $parentArticleId } }
            deactivated: { equals: false }
          }
        ) {
          id
        }
      }
    }
  }
`;
